import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, MessageCircleIcon, VideoIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-brand-bg pt-8 md:pt-12 pb-8 md:pb-10 relative overflow-hidden" data-id="element-244">
      <div className="absolute bottom-0 left-0 right-0 h-[70%] bg-gradient-to-t from-[#22c55e]/10 via-[#22c55e]/5 to-transparent pointer-events-none" data-id="element-245" />
      <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-246" />

      {/* Title + Subtitle */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-248">
          <h1 className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold text-black leading-[1.25] max-w-5xl mx-auto flex flex-col items-center gap-1 text-center" data-id="element-249">
            <span className="md:whitespace-nowrap" data-id="element-250">
              Aprendé a vender{' '}
              <span className="text-[#1fa855] relative" data-id="element-251">
                productos digitales
                <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gray-200 rounded-full" data-id="element-252" />
              </span>
            </span>
            <span className="md:whitespace-nowrap" data-id="element-253">
              o{' '}
              <span className="text-[#1fa855] relative" data-id="element-254">
                físicos
                <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gray-200 rounded-full" data-id="element-255" />
              </span>{' '}
              desde cero
            </span>
          </h1>

          {/* Green divider */}
          <div className="flex justify-center mt-8 mb-8" data-id="element-256">
            <div className="w-16 h-1 rounded-full bg-[#1fa855]" data-id="element-257" />
          </div>

          {/* Video results title + video */}
          <motion.h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-258">
            Descubrí cuánto facturé en menos de 3 meses{' '}
            <span className="text-[#1fa855]" data-id="element-259">CON 1 SOLO PRODUCTO</span>
          </motion.h2>

          <motion.p className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.1
        }} data-id="element-260">
            En este video te enseño mis resultados ⬇
          </motion.p>

          <motion.div className="w-full max-w-3xl mx-auto mb-12 md:mb-16" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-261">
            <div className="relative w-full rounded-2xl bg-brand-card border border-gray-200 shadow-lg" style={{
            paddingBottom: '65%'
          }} data-id="element-262">
              <iframe src="https://fast.wistia.net/embed/iframe/9dsb5tsk42?seo=true&videoFoam=true" title="Video de presentación" allow="autoplay; fullscreen" allowFullScreen className="absolute top-0 left-0 w-full h-full rounded-2xl" style={{
              border: 'none'
            }} data-id="element-263" />
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Carousel - full width */}
      <div className="flex gap-4 overflow-x-auto cursor-grab active:cursor-grabbing snap-x snap-mandatory pl-6 pr-6 relative z-10" style={{
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-264">
        {[{
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/6EjRBRG4ZvzhbrGGft2Pf1/Imagen_28-3-26_a_las_6.44_p._m..jpg'
      }, {
        type: 'video',
        src: 'https://cdn.magicpatterns.com/uploads/fgmiWFwxz9mdRLU5CZhwr7/VIDEODELTAPARACAMPAN%CC%83A.mp4'
      }, {
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/idppeFC4n7nsEuDs5UmUeB/Imagen_28-3-26_a_las_6.52_p._m..jpg'
      }, {
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/6TgDtquuyyH1mGpRCPs5Sw/Imagen_29-3-26_a_las_5.50_p._m..jpg'
      }, {
        type: 'image',
        src: 'https://cdn.magicpatterns.com/uploads/gjPNBPpsxnhmXt7P1dKUsv/Imagen_28-3-26_a_las_6.57_p._m..jpg'
      }].map((item, i) => <div key={i} className="flex-shrink-0 w-[30%] min-w-[260px] rounded-2xl overflow-hidden bg-[#22c55e] shadow-lg snap-start p-3 flex items-center justify-center" data-id="element-265">
            {item.type === 'image' ? <img src={item.src} alt={`Resultado de alumno ${i + 1}`} className="w-full h-auto rounded-xl" draggable={false} data-id="element-266" /> : <video src={item.src} className="w-full h-auto rounded-xl" autoPlay muted loop playsInline data-id="element-267" />}
          </div>)}
      </div>

      {/* Rest of hero content */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-268">
        {/* Esto es para vos si... */}
        <motion.div className="mt-20 mb-16 max-w-3xl mx-auto text-left" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-bold text-black text-center mb-10" data-id="element-270">
            ESTO ES PARA VOS SI...
          </h2>
          <div className="space-y-6" data-id="element-271">
            {[{
            text: <>
                    Tenés un ebook o querés crear uno, pero{' '}
                    <strong className="text-gray-900" data-id="element-272">
                      no sabés cómo venderlo ni por dónde empezar.
                    </strong>
                  </>
          }, {
            text: <>
                    Querés{' '}
                    <strong className="text-gray-900" data-id="element-273">
                      revender productos físicos por internet
                    </strong>{' '}
                    o los productos que vos elaborás y{' '}
                    <strong className="text-gray-900" data-id="element-274">
                      no sabés por dónde empezar.
                    </strong>
                  </>
          }, {
            text: <>
                    Sentís que podrías{' '}
                    <strong className="text-gray-900" data-id="element-275">
                      generar ingresos con lo que sabés
                    </strong>
                    , pero la parte técnica te frena (tienda, pagos,
                    automatización...).
                  </>
          }, {
            text: <>
                    Sos emprendedor/emprendedora y hacés todo sola/o, y{' '}
                    <strong className="text-gray-900" data-id="element-276">
                      necesitás una forma simple de vender
                    </strong>{' '}
                    sin agregar más tareas a tu rutina.
                  </>
          }, {
            text: <>
                    Estás cansada/o de ver cursos que te dan vueltas, y{' '}
                    <strong className="text-gray-900" data-id="element-277">
                      querés un curso práctico, claro y directo
                    </strong>{' '}
                    que puedas aplicar hoy mismo.
                  </>
          }, {
            text: <>
                    Querés lanzar tu tienda digital,{' '}
                    <strong className="text-gray-900" data-id="element-278">
                      automatizar tus ventas 24/7
                    </strong>{' '}
                    sin depender de Instagram o WhatsApp.
                  </>
          }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-279">
                <div className="w-8 h-8 rounded-full bg-[#22c55e] flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm shadow-[#22c55e]/20" data-id="element-280">
                  <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-281">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-282" />
                  </svg>
                </div>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-283">
                  {item.text}
                </p>
              </div>)}
          </div>
        </motion.div>

        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-284">
          {/* CTA Button and Feature Cards */}
          <div className="mt-10 flex flex-col items-center" data-id="element-285">
            <a href="#" onClick={e => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-xl px-16 py-5 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_rgba(34,197,94,0.3)] hover:shadow-[0_0_60px_rgba(34,197,94,0.4)] cursor-pointer" data-id="element-286">
              🔥 Acceder Ahora
            </a>
            <p className="mt-5 text-gray-600 text-base md:text-lg font-medium" data-id="element-287">
              ⚡ Acceso Inmediato + De 0 a Escalado en Meta
            </p>

            {/* Feature Cards */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 w-full max-w-5xl" data-id="element-288">
              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-289">
                <div className="flex items-start gap-3 mb-3" data-id="element-290">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-291">
                    <GraduationCapIcon className="w-5 h-5 text-brand-green" data-id="element-292" />
                  </div>
                  <div data-id="element-293">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-294">
                      Alumnos con resultados{' '}
                      <span className="text-brand-green" data-id="element-295">REALES</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-296">
                  Casos comprobados y testimonios verificables.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-297">
                <div className="flex items-start gap-3 mb-3" data-id="element-298">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-299">
                    <MessageCircleIcon className="w-5 h-5 text-brand-green" data-id="element-300" />
                  </div>
                  <div data-id="element-301">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-302">
                      Comunidad VIP en WhatsApp
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-303">
                  Soporte cercano y respuesta rápida 24/7.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-304">
                <div className="flex items-start gap-3 mb-3" data-id="element-305">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-306">
                    <VideoIcon className="w-5 h-5 text-brand-green" data-id="element-307" />
                  </div>
                  <div data-id="element-308">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-309">
                      Mentorías grupales semanales{' '}
                      <span className="text-brand-green" data-id="element-310">EN VIVO</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-311">
                  Correcciones, estrategia y dudas resueltas en directo.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}